<template>
  <div class="campaign-prize" v-loading="!loaded">
    <TikTokPrizeDialog ref="tiktokPrizeDialog"></TikTokPrizeDialog>
    <div class="mb-x2" layout="layout" layout-align="space-between-center">
      <div layout="layout">
        <div class="mr-x1">
          <el-button class="el-button-mt" type="default" @click="onChangeBackEvent"
            ><i class="mdi mdi-arrow-left"></i>戻る</el-button
          >
        </div>
      </div>
      <div v-if="campaign.id" layout="row" layout-align="end-center">
        <div class="mr-x3">応募者数: {{ formatNumber(campaign.applicantsCount) }}</div>
        <div class="mr-x3">
          当選者数: {{ formatNumber(campaign.winnerCount) }}(残り{{
            formatNumber(campaign.maxWinnerCount - campaign.winnerCount)
          }})
        </div>
        <div class="mr-x3">回答者数: {{ formatNumber(campaign.responderCount) }}</div>
        <div>データ取得日時: {{ lastProcessedDatetime }}</div>
      </div>
    </div>
    <div v-if="isCampaignBeforeStart">
      <div class="mb-x2">
        <div class="message message-info">
          このキャンペーンは、{{
            campaignStartDatetime
          }}から開催されます。<br />初回の応募収集は、キャンペーン開催から30分後です。
        </div>
      </div>
    </div>
    <div v-else-if="isCampaignBeforeCollect">
      <div class="mb-x2">
        <div class="message message-info">
          初回の応募収集は、キャンペーン開催から30分後です。<br />応募収集が開始されるまで、しばらくお待ちください。
        </div>
      </div>
    </div>
    <div v-else-if="isCampaignFinalCollection">
      <div class="mb-x2">
        <div class="message message-info">
          現在、応募データの最終集計処理を行なっています。<br />{{
            collectCompletedAt
          }}ごろまでに全応募データが反映されます。
        </div>
      </div>
    </div>
    <div v-else-if="isCampaignCollectionCompleted">
      <div class="mb-x2">
        <div class="message message-info">
          キャンペーン期間が終了しました。<br />応募者一覧から当選者の選定および、当選メッセージを配信してください。
        </div>
      </div>
    </div>
    <el-card v-if="!error">
      <div class="mb-x3" layout="row" layout-align="space-between-center">
        <div class="header-left" layout="row">
          <el-button
            v-if="campaign.type !== 'old_web_instantwin'"
            type="primary"
            :disabled="isCampaignFinalCollection || isCampaignCollectionCompleted"
            @click="onChangeTikTokPrizeDialogEvent"
            ><i class="mdi mdi-plus"></i>応募グループの新規作成</el-button
          >
        </div>
        <div class="header-right" layout="row">
          <el-button class="mr-x1" type="default" @click="onChangeTikTokPostEvent"
            ><i class="mdi mdi-format-list-bulleted"></i>応募履歴</el-button
          >
          <CsvDownload v-if="!error && prizes.length" :download="downloadCsv"></CsvDownload>
        </div>
      </div>
      <div class="message message-error" v-if="loaded && !prizes.length">
        キャンペーン開始日時までに応募グループを作成してください。<br />応募グループがない場合、データを取得できません。'
        }}
      </div>
      <TikTokPrizeTable
        v-if="prizes.length"
        :prizes="prizes"
        :options="options"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
        :onChangeSortBy="onChangeSortBy"
      ></TikTokPrizeTable>
    </el-card>
    <el-card v-else>
      <div class="message message-error">
        データ取得に失敗しました。恐れ入りますが、時間を置いて再度お試しください。
      </div>
    </el-card>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import CsvDownload from '@/client/components/_atoms/csv_download'
import { CAMPAIGN_STATUS } from '@/client/constant'
import api from '@/client/core/api'
import util from '@/client/core/util'
import TikTokPrizeDialog from '@/client/features/tiktok_campaign_prize/tiktok_prize_dialog'
import TikTokPrizeTable from '@/client/features/tiktok_campaign_prize/tiktok_prize_table'
import { formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useCampaignStore } from '@/client/store/useCampaignStore'
import { useNavbarStore } from '@/client/store/useNavbarStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTikTokCampaignPrizeStore } from '@/client/store/useTikTokCampaignPrizeStore'

export default defineComponent({
  components: {
    CsvDownload,
    TikTokPrizeTable,
    TikTokPrizeDialog
  },
  data: () => {
    return {
      isLeave: false
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      currentGroupId: state => state.currentGroup.id
    }),
    ...mapState(useCampaignStore, {
      lastQueryParams: state => state.lastQueryParams
    }),
    ...mapState(useTikTokCampaignPrizeStore, {
      prizes: state => state.prizes,
      error: state => state.error,
      params: state => state.params,
      loaded: state => state.firstLoaded,
      campaign: state => state.campaign ?? {},
      options: state => ({
        total: state.total,
        pagingNo: state.params.pagingNo,
        limitCount: state.params.limitCount,
        sortBy: state.params.sortBy
      })
    }),

    lastProcessedDatetime() {
      if (!this.campaign.lastProcessedDatetime) {
        return '-'
      }

      return moment(this.campaign.lastProcessedDatetime).format('YYYY年MM月DD日 HH:mm')
    },

    campaignStartDatetime() {
      return moment(this.campaign.startDatetime).format('YYYY年MM月DD日 HH:mm')
    },

    collectCompletedAt() {
      // 分析バッチの実行完了を考慮し、キャンペーン終了時刻の1時間後を表示する
      return moment(this.campaign.endDatetime).add(2, 'days').format('YYYY年MM月DD日 HH:mm')
    },

    isCampaignBeforeStart() {
      return this.campaign.status === CAMPAIGN_STATUS.BEFORE_EVENT
    },

    isCampaignBeforeCollect() {
      return this.campaign.status === CAMPAIGN_STATUS.BEFORE_COLLECTION
    },

    isCampaignFinalCollection() {
      return this.campaign.status === CAMPAIGN_STATUS.DURING_FINAL_COLLECTION
    },

    isCampaignCollectionCompleted() {
      return this.campaign.status === CAMPAIGN_STATUS.COLLECTION_COMPLETED
    }
  },
  async mounted() {
    const params = {
      campaignId: this.$route.params.campaignId
    }

    this.setParams(params)

    await this.fetchCampaign()

    if (this.isLeave || !this.campaign || !this.campaign.id) {
      return
    }

    if (this.currentGroupId !== this.campaign.groupId) {
      this.setCurrentGroup(this.campaign.groupId)
    }

    this.setBreadcrumb([
      {
        name: 'キャンペーン一覧',
        link: '/campaigns'
      },
      {
        name: this.campaign.title,
        link: null,
        iconName: this.campaign.account ? this.campaign.account.name : '削除されたアカウント',
        iconUrl: this.campaign.account ? this.campaign.account.pictureUrl : null,
        iconType: this.campaign.snsType,
        isIcon: true
      }
    ])
  },
  watch: {
    params() {
      this.fetchPrizes()
    }
  },
  methods: {
    formatNumber,

    ...mapActions(useSystemStore, ['setCurrentGroup']),
    ...mapActions(useTikTokCampaignPrizeStore, ['fetchPrizes', 'setParams', 'fetchCampaign', 'reset']),
    ...mapActions(useNavbarStore, ['setBreadcrumb']),

    /**
     * CSVダウンロード
     */
    async downloadCsv() {
      TrackingService.sendEvent('click:応募グループ一覧（TikTok）|CSVダウンロード')

      const params = Object.assign({}, this.params, {
        forCsv: 1
      })
      const result = await api.get('/tiktok_campaign_prizes', {
        params
      })

      if (!result.data) {
        return {
          error: 'ERROR_LOADING'
        }
      }

      const prizes = result.data.prizes
      const filename = `campaign_prize_${this.campaign.title}_applicants_${moment().format('YYYY_MM_DD')}`
      const csvData = []
      csvData.push(['応募グループ名', '応募キーワード', '応募者数', '当選者数', '当選者数(残り)'])

      // CSVデータを格納
      prizes.forEach(prize => {
        csvData.push([
          prize.name,
          prize.entryKeyword,
          prize.applicantCount,
          prize.winnerCount,
          prize.maxWinnerCount - prize.winnerCount
        ])
      })

      return {
        filename,
        data: csvData
      }
    },

    /**
     * ページを変更イベント
     * @param {number} page ページ
     */
    onChangePagingNo(page: number) {
      if (this.params.pagingNo === page) {
        return
      }
      this.setParams({ pagingNo: page })
      util.scrollToTop()
    },

    /**
     * リミット数を変更イベント
     * @param {number} limitCount リミット数
     */
    onChangeLimitCount(limitCount: number) {
      if (this.params.limitCount === limitCount) {
        return
      }
      this.setParams({ limitCount })
    },

    /**
     * ソートを変更イベント
     * @param {string} sortBy ソート
     */
    onChangeSortBy(sortBy: string) {
      if (this.params.sortBy === sortBy) {
        return
      }
      this.setParams({ sortBy })
    },

    onChangeBackEvent() {
      TrackingService.sendEvent('click:応募グループ一覧（TikTok）|戻る')

      // 保存されたクエリパラメータがあれば復元、なければそのまま
      const query = this.lastQueryParams || {}
      this.$router.push({ path: '/campaigns', query })
    },

    onChangeTikTokPrizeDialogEvent() {
      TrackingService.sendEvent('click:応募グループ一覧（TikTok）|応募グループの新規作成')

      this.$refs.tiktokPrizeDialog.open(this.campaign.id)
    },

    onChangeTikTokPostEvent() {
      TrackingService.sendEvent('click:応募グループ一覧（TikTok）|応募履歴')

      this.$router.push('/campaigns/' + this.campaign.id + '/tiktok_posts')
    }
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    this.isLeave = true
    next()
  }
})
</script>
